
export const Indicators = [
    {
        id: 16,
        name: "Totaal hernieuwbare energie",
        unit: "MJ, ncw"
    },
    {
        id: 17,
        name: "Totaal niet hernieuwbare energie",
        unit: "MJ, ncw"
    },
    {
        id: 18,
        name: "Energie",
        unit: "MJ, ncw"
    },
    {
        id: 19,
        name: "Netto gebruik van zoet water",
        unit: "m3"
    },
    {
        id: 20,
        name: "Niet-gevaarlijk afval",
        unit: "kg"
    },
    {
        id: 21,
        name: "Gevaarlijk afval",
        unit: "kg"
    },
    {
        id: 22,
        name: "Gebruik van secundaire materialen",
        unit: "kg"
    },
    {
        id: 23,
        name: "Gebruik van hernieuwbare secundaire brandstoffen",
        unit: "MJ, ncw"
    },
    {
        id: 24,
        name: "Gebruik van niet-hernieuwbare secundaire brandstoffen",
        unit: "MJ, ncw"
    },
    {
        id: 25,
        name: "Materialen voor hergebruik",
        unit: "kg"
    },
    {
        id: 26,
        name: "Materialen voor recycling",
        unit: "kg"
    },
    {
        id: 27,
        name: "Materialen voor energie",
        unit: "kg"
    },
    {
        id: 28,
        name: "Geëxporteerde energie",
        unit: "MJ/energiedrager"
    },
];